<div class="File-details flex flex-col">
  <div class="File-details__preview">
    <img
      *ngIf="items.length == 1 && items[0].isImage()"
      [src]="items[0].getFilePath({ w: 300 }) | secureImg"
      class="File-details__preview__image"
    />
    <mat-icon *ngIf="items.length == 1 && !items[0].isImage()" class="File-details__preview__icon">{{ items[0].getIconString() }}</mat-icon>
    <mat-grid-list class="File-details__grid" *ngIf="items.length > 1" [cols]="3" gutterSize="2px">
      <mat-grid-tile *ngFor="let i of items">
        <img [src]="i.getFilePath({ w: 300 }) | secureImg" *ngIf="i.isImage()" class="File-details__preview__image" />
        <mat-icon *ngIf="!i.isImage()" class="File-details__preview__icon File-details__preview__icon--in-grid">{{
          i.getIconString()
        }}</mat-icon>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
  <h3 class="File-details__name" *ngIf="items.length == 1">{{ items[0].title }}</h3>
  <h3 class="File-details__name" *ngIf="items.length > 1">{{ items.length }} {{ 'MEDIA.FILES_CHOSEN' | translate }}</h3>

  <div class="File-details__meta" *ngIf="items.length == 1">
    <dl class="File-details__description-list base-dl">
      <ng-container *ngFor="let detail of items[0] | fileDetails">
        <dt>{{ detail.label | translate }}</dt>
        <dd>{{ detail.value ?? '&nbsp;' }}</dd>
      </ng-container>
    </dl>
  </div>
</div>

<div class="Rule-violations flex flex-col" [class.Rule-violations--hidden]="CAN_RETURN_FILES || !options.expectsValue">
  <div *ngFor="let item of items; let i = index" class="Rule-violations__item">
    <div class="flex flex-col p-5" *ngIf="item.getMetaField('rule-violation')">
      <span class="mat-caption" [hidden]="items.length < 2"
        ><b>{{ 'MEDIA.IMAGE' | translate }}: {{ i + 1 }}</b></span
      >
      <span class="mat-subtitle-2" *ngFor="let message of item.getMetaFieldsValue('rule-violation')" [innerHTML]="message"></span>
    </div>
    <mat-divider [hidden]="items.length < 2 || i === items.length - 1"></mat-divider>
  </div>
</div>

<div *awIsGod>
  <form class="flex flex-col p-2 w-full" [formGroup]="mediaForm" *ngIf="items.length === 1 && mediaForm">
    <mat-form-field appearance="fill" class="w-full">
      <input matInput placeholder="Alias" formControlName="alias" />
    </mat-form-field>
    <div class="flex justify-end">
      <mat-slide-toggle color="primary" formControlName="public">Publik</mat-slide-toggle>
    </div>
  </form>
</div>

<div class="flex gap-2 px-2">
  <div>
    <button
      mat-icon-button
      [matTooltip]="'MEDIA.DOWNLOAD' | translate"
      matTooltipPosition="above"
      (click)="download(true)"
      [hidden]="items.length !== 1 || items[0].isBucket()"
    >
      <mat-icon>cloud_download</mat-icon>
    </button>

    <button
      mat-icon-button
      [matTooltip]="'MEDIA.DISPLAY' | translate"
      matTooltipPosition="above"
      (click)="download()"
      [hidden]="items.length !== 1 || items[0].isBucket()"
    >
      <mat-icon>remove_red_eye</mat-icon>
    </button>

    <button
      *ngIf="(isGod$ | async) === false"
      mat-icon-button
      [hidden]="items.length !== 1 || items[0].isBucket()"
      [matTooltip]="'MEDIA.COPY_LINK' | translate"
      matTooltipPosition="above"
      (click)="copyFileLink()"
    >
      <mat-icon>link</mat-icon>
    </button>

    <button *ngIf="isGod$ | async" mat-icon-button [hidden]="items.length !== 1 || items[0].isBucket()" [matMenuTriggerFor]="linkMenu">
      <mat-icon>link</mat-icon>
    </button>

    <button
      mat-icon-button
      [matTooltip]="'MEDIA.EDIT_FILE' | translate"
      matTooltipPosition="above"
      (click)="editTitle()"
      [hidden]="items.length !== 1"
    >
      <mat-icon>mode_edit</mat-icon>
    </button>
    <button mat-icon-button [matTooltip]="'MEDIA.DELETE' | translate" matTooltipPosition="above" (click)="deleteSelectedItems()">
      <mat-icon>delete</mat-icon>
    </button>
  </div>

  <button
    [hidden]="!options.expectsValue || !files.length"
    mat-raised-button
    color="primary"
    (click)="returnSelectedFiles()"
    [disabled]="!CAN_RETURN_FILES"
  >
    {{ 'MEDIA.PICK' | translate }}
  </button>
</div>

<mat-menu #linkMenu="matMenu">
  <button mat-menu-item (click)="copyFileLink()">Kopiera länk</button>
  <button mat-menu-item (click)="copyFileLink(true)">Kopiera länk med alias</button>
</mat-menu>
